import { RootState } from '../types';

export const selectSelectedDisplayModeType = (state: RootState) =>
  state.reducer.scheduleUIState.selectedDisplayMode.type;

export const selectScheduleUISettings = (state: RootState) => state.reducer.scheduleUIState.settings;
